import { ApiError, getQueue, putQueue, readForFiling, removeFromQueue } from '../api';
import type { ReviewList } from '../ReviewList';
import { type IInboxDeps, TrialEndedError } from './inbox';

/**
 * The Inbox check from the browser: reading and the review queue go through our API. With a
 * review list, the queue is mirrored to the Filing Review list in SharePoint after it changes.
 */
export function browserInboxDeps(driveId: string, reviewList?: ReviewList): IInboxDeps {
  return {
    read: async files => {
      try {
        return await readForFiling(driveId, files);
      } catch (e) {
        if (e instanceof ApiError && e.status === 402) {
          throw new TrialEndedError(e.message, e.left ?? 0);
        }
        throw e;
      }
    },
    getQueue: () => getQueue(driveId),
    putQueue: items => putQueue(driveId, items),
    removeFromQueue: ids => removeFromQueue(driveId, ids),
    afterQueueChange: reviewList ? items => reviewList.sync(items) : undefined
  };
}
